/**
 * Builds the URL for PDF downloads served via the backend (SharePoint proxy).
 * In development uses the backend origin (localhost:3002) so the link opens the API directly;
 * in production uses same origin so /api/pdf is served by your API host.
 */
export function getPdfDownloadUrl(serverRelativeUrl: string, fileName: string): string {
  const base =
    process.env.NODE_ENV === 'production'
      ? ''
      : (process.env.REACT_APP_API_URL || 'http://localhost:3002/api/folders').replace(
          /\/api\/folders\/?$/,
          ''
        );
  const params = new URLSearchParams({
    serverRelativeUrl,
    fileName,
  });
  return `${base}/api/pdf?${params.toString()}`;
}
